import ButtonGroup from 'admin/components/molecules/ButtonGroup';
import Breadcrumb from 'admin/components/shared/Breadcrumb';
import queryString from 'query-string';
import React, { useCallback, useState } from 'react';
import CSSModules from 'react-css-modules';
import { useHistory, useLocation } from 'react-router-dom';
import styled from 'styled-components';
import { useAppSelector } from '~/javascripts/admin/hooks/useApp';
import { selectUserPrivateMoney } from '../../../reducers/user-private-money';
import { Button } from '../../atoms/Buttons';
import UserPrivateMoneyNotAllowed from '../../atoms/UserPrivateMoneyNotAllowed';
import ApiResults from '../../molecules/ApiResults';
import SelectedPrivateMoneyDisplay from '../../organisms/SelectedPrivateMoneyDisplay';
import CollectableRewards from './CollectableRewards';
import DirectRewards from './DirectRewards';
import styles from './styles.scss';

const CreateNewButton = styled(Button)`
  margin-bottom: 16px;
`;

const ButtonsWrapper = styled.div`
  padding: 12px 0;
`;

const TABS = [
  { text: '受取リクエスト方式', value: 'collectable' },
  { text: '直接付与方式', value: 'direct' },
];

const Rewards = () => {
  const history = useHistory();
  const location = useLocation();
  const params = queryString.parse(location.search);

  const user = useAppSelector((state) => state.user);
  const userPrivateMoney = useAppSelector(selectUserPrivateMoney);

  const allowedPrivateMoneys = user.issuedMoneys();
  const isSelectedMoneyAllowed =
    user.isServiceUser() || allowedPrivateMoneys.some((m) => m.id === userPrivateMoney.id);

  const crumb = [
    { value: 'ホーム', href: '/', active: false },
    { value: '販促管理', href: '', active: true },
    { value: 'マネー/ポイント付与管理', href: '', active: true },
  ];

  const getActiveTabIndex = () => {
    const tab = params?.tab;
    return typeof tab === 'string' ? Number(tab) : 0;
  };

  const activeTabIndex = getActiveTabIndex();

  const [apiMessages, setApiMessages] = useState(undefined);

  const handleSelectTab = useCallback(
    (index) => {
      history.push(`/promotion/rewards?tab=${index}`);
    },
    [history]
  );

  return (
    <>
      <Breadcrumb items={crumb} />
      <div styleName="headline">マネー/ポイント付与管理</div>
      <CreateNewButton onClick={() => history.push('/promotion/rewards/create')}>
        新規作成
      </CreateNewButton>
      <SelectedPrivateMoneyDisplay
        highlightHeader={!isSelectedMoneyAllowed}
        allowedPrivateMoneys={allowedPrivateMoneys}
      />
      {!isSelectedMoneyAllowed && <UserPrivateMoneyNotAllowed />}
      {isSelectedMoneyAllowed && (
        <>
          <ButtonsWrapper>
            <ButtonGroup
              buttons={TABS}
              activeIndex={activeTabIndex}
              onClick={(_, index) => handleSelectTab(index)}
            />
          </ButtonsWrapper>
          <ApiResults messages={apiMessages} />
          {
            [
              <CollectableRewards
                history={history}
                selectedMoneyId={userPrivateMoney.id}
                setApiResult={setApiMessages}
              />,
              <DirectRewards selectedMoneyId={userPrivateMoney.id} setApiResult={setApiMessages} />,
            ][activeTabIndex]
          }
        </>
      )}
    </>
  );
};

export default CSSModules(Rewards, styles, { allowMultiple: true });
